import React from 'react';

import Horticulture from 'views/Horticulture';

const SchoolProgrampage = () => {
  return <Horticulture />;
};

export default SchoolProgrampage;